import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { deleteMedia } from "../../../../api/apiServices";
import MediaPreviewModal from "./MediaPreviewModal";

export default function MediaGallery({ mediaList, onMediaDeleted }) {
  const [selected, setSelected] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this media?")) return;

    try {
      setDeletingId(id);
      await deleteMedia(id);
      onMediaDeleted(); 
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete media");
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Gallery</h2>

      {mediaList.length === 0 ? (
        <p className="text-slate-500">No media uploaded yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-4">
          <AnimatePresence>
            {mediaList.map((item) => (
              <motion.div
                key={item._id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.25 }}
                className="relative group cursor-pointer rounded-lg overflow-hidden border border-slate-200"
              >
                <div onClick={() => setSelected(item)}>
                  {item.url.endsWith(".mp4") ? (
                    <video
                      src={item.url}
                      className="w-full h-32 object-cover"
                      muted
                    />
                  ) : (
                    <img
                      src={item.url}
                      alt={item.category}
                      className="w-full h-32 object-cover"
                    />
                  )}
                  <span className="absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded">
                    {item.category}
                  </span>
                </div>

                {/* Delete Button */}
                <button
                  onClick={() => handleDelete(item._id)}
                  disabled={deletingId === item._id}
                  className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                >
                  {deletingId === item._id ? "..." : "Delete"}
                </button>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      )}

      {selected && (
        <MediaPreviewModal media={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
}
